import { render, staticRenderFns } from "./CompanyCommissionsTable.vue?vue&type=template&id=2f52865e&scoped=true"
import script from "./CompanyCommissionsTable.vue?vue&type=script&lang=ts"
export * from "./CompanyCommissionsTable.vue?vue&type=script&lang=ts"
import style0 from "./CompanyCommissionsTable.vue?vue&type=style&index=0&id=2f52865e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f52865e",
  null
  
)

export default component.exports